/**
 *
 * @param {string} key
 *
 * @return {string|null}
 */
export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

/**
 *
 * @param {string} key
 * @param {string} value
 *
 * @return {void}
 */
export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};

/**
 *
 * @param {string} key
 *
 * @return {void}
 */
export const removeItemLocalStorage = (key) => {
  localStorage.removeItem(key);
};
